
/**
 * Gives legal terms path from go.sellsy
 * @type {Object.<string, string>}
 */
export const legalTermsPath = {
    'fr': 'informations-legales/informations-et-mentions-legales',
    'en': 'en/legal-information/legal-information'
};

/**
 * Gives general conditions path from go.sellsy
 * @type {Object.<string, string>}
 */
 export const generalConditionsPath = {
    'fr': 'informations-legales/conditions-generales#cgu',
    'en': 'en/legal-information/general-terms-and-conditions#gtcu'
};


/**
 * Gives privacy policy path from go.sellsy
 * @type {Object.<string, string>}
 */
export const privacyPolicyPath = {
    'fr': 'informations-legales/politique-de-confidentialite',
    'en': 'en/legal-information/privacy-policy'
};

/**
 * Gives offers path from go.sellsy
 * @type {Object.<string, string>}
 */
 export const offersPath = {
    'fr': 'offres',
    'en': 'en/offers'
};

/**
 * @param {string} lang
 * @param {Object} page
 * @returns {string}
 */
export const getGoSellsyUrl = (lang, page) => {
    if (!['fr', 'en'].includes(lang)) {
        lang = 'fr';
    }
    if (!page.hasOwnProperty(lang)) {
        console.warn("link not available");
        return '';
    }

    return `https://go.sellsy.com/${page[lang]}`;
};
